import React, { useEffect, useState } from 'react';
import './App.css'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import dayjs from 'dayjs';
import SendIcon from '@mui/icons-material/Send';
import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import qs from 'qs'


function CommentsCard({ defaultValues, callback }) {
  const [comments, setComments] = useState("")

  useEffect(() => {
    setComments(defaultValues?.comment || "")
  }, [defaultValues])

  return <div className="card comments">
    <div className="title">أي اقتراحات أو تعليقات تود إضافتها:</div>
    <TextField
      id="customer-name"
      placeholder="أدخل النص"
      variant="outlined"
      size="small"
      fullWidth
      multiline
      value={comments}
      onChange={e => {
        setComments(e.target.value)
        callback("comment", e.target.value)
      }}
      rows={4} />
  </div>
}


function CustomerInfoCard({ defaultValues, callback }) {
  const [cname, setCname] = useState("")
  const [phone, setPhone] = useState("")

  useEffect(() => {
    setCname(defaultValues?.name || "")
    setPhone(defaultValues?.phone || "")
  }, [defaultValues])

  return <div className="card customer-info">
    <div className="title">*معلومات الاتصال الخاصة بك</div>
    <Box
      component="form"
      noValidate
      autoComplete='off'
      className="question">
      <div className="answer">
        <TextField value={cname} id="customer-name" label="الاسم" variant="outlined" size="small" fullWidth onChange={e => {
          setCname(e.target.value)
          callback("name", e.target.value)
        }} />
        <TextField value={phone} id="customer-phone" label="رقم  الهاتف" variant="outlined" size="small" fullWidth onChange={e => {
          setPhone(e.target.value)
          callback("phone", e.target.value)
        }} />
      </div>
    </Box>
  </div >
}

function ExperienceRating({ defaultValues, callback }) {
  const [uKey, setUKey] = useState("")

  useEffect(() => {
    setUKey(Date.now()) // force refresh of components
  }, [defaultValues])

  return <div className="card experience">
    <div className="title" style={{ marginBottom: "1.5rem" }}>*يرجى تقييم الخدمات التالية</div>
    {[
      ["جودة الطعام", "food_quality"],
      ["جودة الاركيلة", "narguile_quality"],
      ["جودة المشروبات", "drinks_quality"],
      ["جودة وطريقة تقديم الطلبات وتزيينها", "food_presentation"],
      ["سرعة تقديم الطلبات", "service_speed"],
      ["دقة تقديم الطلبات", "service_exactitude"],
      ["النظافة", "cleanliness"],
      ["التجربة بشكل عام", "overall"],
    ].map(field => <div className="question inline" key={field[1] + uKey}>
      <div className="description">{field[0]}</div>
      <FormControl className="answer" fullWidth sx={{ maxWidth: "30rem" }}>
        <RadioGroup
          row
          defaultValue={defaultValues ? defaultValues[field[1]] : null}
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          onChange={e => callback(field[1], e.target.value)}
          sx={{ justifyContent: "space-between", flexDirection: { xs: "column", sm: "row" } }}
        >
          <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value="ممتازة" control={<Radio size="small" />} label="ممتازة" />
          <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value="جيدة جداً" control={<Radio size="small" />} label="جيدة جداً" />
          <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value="متوسطة" control={<Radio size="small" />} label="متوسطة" />
          <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value="سيئة" control={<Radio size="small" />} label={"سيئة"} />
        </RadioGroup>
      </FormControl>
    </div>)}
  </div>
}

function YesNoQuestion({ label, description, callback, field, defaultValues, other }) {
  const [uKey, setUKey] = useState("")

  useEffect(() => {
    setUKey(Date.now()) // force refresh of components
  }, [defaultValues])

  return <div className="card experience" key={field + uKey}>
    <div className="title" style={{ marginBottom: "0.5rem" }}>{label}</div>
    {description && <div style={{ fontSize: "90%", marginBottom: "1.5rem" }}>{description}</div>}
    <FormControl className="answer" fullWidth sx={{ maxWidth: "30rem" }}>
      <RadioGroup
        row
        defaultValue={defaultValues ? ((["true", "false"].includes(defaultValues[field]) || !defaultValues[field]) ? defaultValues[field] : "other") : null}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={e => callback(field, e.target.value)}
        sx={{ flexDirection: "column" }}
      >
        <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value="true" control={<Radio size="small" />} label="نعم" />
        <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value="false" control={<Radio size="small" />} label="لا" />
        {other && <div style={{ display: "flex" }}>
          <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value={"other"} control={<Radio size="small" />} label={"آخر"} />
          <TextField defaultValue={defaultValues ? (["true", "false"].includes(defaultValues[field]) ? "" : defaultValues[field]) : null} variant="standard" fullWidth size="small" style={{ marginInline: "0.5rem" }} onChange={(e) => callback(field, e.target.value)} />
        </div>}
      </RadioGroup>
    </FormControl>
  </div>
}

function SingleChoiceQuestion({ label, description, callback, field, options, defaultValues, other }) {
  const [uKey, setUKey] = useState("")

  useEffect(() => {
    setUKey(Date.now()) // force refresh of components
  }, [defaultValues])

  const isOther = defaultValues && !options.includes(defaultValues[field]) && defaultValues[field]

  // TODO: Yes / No  is just a special case of SingleChoiceQuestion
  return <div className="card experience" key={field + uKey}>
    <div className="title" style={{ marginBottom: "0.5rem" }}>{label}</div>
    {description && <div style={{ fontSize: "90%", marginBottom: "1.5rem" }}>{description}</div>}
    <FormControl className="answer" fullWidth sx={{ maxWidth: "30rem" }}>
      <RadioGroup
        row
        defaultValue={defaultValues ? (isOther ? "other" : defaultValues[field]) : null}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={e => callback(field, e.target.value)}
        sx={{ flexDirection: "column" }}
      >
        {options.map(option => <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value={option} control={<Radio size="small" />} label={option} />)}
        {other && <div style={{ display: "flex" }}>
          <FormControlLabel labelPlacement="end" sx={{ margin: "inherit" }} value={"other"} control={<Radio size="small" />} label={"آخر"} />
          <TextField defaultValue={isOther ? defaultValues[field] : ""} variant="standard" fullWidth size="small" style={{ marginInline: "0.5rem" }} onChange={(e) => callback(field, e.target.value)} />
        </div>}
      </RadioGroup>
    </FormControl>
  </div>
}

function App() {
  const [successSend, setSuccessSend] = useState(false)
  const [sendError, setSendError] = useState("")
  const [loadingError, setLoadingError] = useState("")
  const [sending, setSending] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadedAnswers, setLoadedAnswers] = useState(null)

  const answerId = qs.parse(window.location.search, { ignoreQueryPrefix: true }).answerId || null

  var surveyAnswer = { date_of_stay: dayjs(Date.now()) }

  useEffect(() => {
    if (answerId) loadAnswer()
  }, [])

  const restaurantId = (() => {
    const parts = window.location.pathname.split("/")
    if (parts.length > 1) return parts[1]
    return null
  })()

  function updateAnswer(key, value) {
    surveyAnswer[key] = value
  }

  function loadAnswer() {
    setLoading(true)

    fetch(`https://api.takeaseat.io/private-survey/${answerId}`, { //https://api.takeaseat.io
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: "include"
    }).then(resp => {
      if (resp.status === 200) {
        resp.json().then(data => setLoadedAnswers(data[0].answers))
      } else {
        setLoadingError("Error.")
      }
      setLoading(false)
    })
  }

  function saveAnswer() {
    console.log(surveyAnswer)
    if (!sending) {
      setSending(true)
      setSendError("")
      const requiredFields = [
        "name",
        "phone",
        "menu_variety",
        "opening_hours",
        "staff_interaction",
        "customer_handling",
        "price",
        "get_to_know",
        "comeback",
        "reasons_to_visit",
        "food_quality",
        "narguile_quality",
        "drinks_quality",
        "food_presentation",
        "service_speed",
        "service_exactitude",
        "cleanliness",
        "overall"
      ]

      for (let field of requiredFields) {
        if (!surveyAnswer[field]) {
          setSending(false)
          setSendError("جميع الحقول مع * مطلوبة")
          return
        }
      }

      fetch(`https://api.takeaseat.io/survey/${restaurantId}`, { //api.takeaseat.io
        method: 'put',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "answers": surveyAnswer })
      }).then(data => {
        setSending(false)
        if (data.status === 200) {
          setSuccessSend(true)
        } else {
          setSuccessSend(false)
          setSendError("Error.")
        }
      })
    }
  }

  return (
    <div style={{
      padding: "1rem",
      display: "flex"
    }}
      className="App"
    >
      {loading && <div
        style={{ backdropFilter: "blur(3px)", zIndex: "2", position: "fixed", inset: "0", background: "rgba(250, 250, 250, 0.7)", fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center" }}
      ><span>Loading...</span></div>}
      {loadingError && <div
        style={{ backdropFilter: "blur(3px)", zIndex: "2", position: "fixed", inset: "0", background: "rgba(250, 250, 250, 0.7)", fontWeight: "bold", display: "flex", justifyContent: "center", alignItems: "center", color: "red" }}
      ><span>{loadingError}</span></div>}
      <div className="content">
        <div style={{ textAlign: "center" }}>
          <img alt="Logo" width="180" height="180" data-type="image" itemprop="image" src="https://public.takeaseat.io/restaurants/7965ba8a-d992-463b-9cc3-0359eec0ff69/388746AF-FDEE-416A-AF84-C7CB4D6329FA.png" class="menu-logo" style={{ objectFit: "contain", objectPosition: "center center" }} />
        </div>
        <h1 style={{ marginBottom: "3rem", color: "white" }}>استبيان رضى الزبائن الكرام .... مطعم وقهوة ترغلة</h1>
        <div style={{ marginBottom: "3rem", color: "white" }}>حرصاً على رضى زبائننا الكرام ورغبة منا في تحسين خدماتنا وتقديمها بأفضل جودة ممكنة نرجو منكم مساعدتنا بذلك عبر اكمال الاستبيان ادناه...</div>
        <CustomerInfoCard callback={updateAnswer} defaultValues={loadedAnswers} />
        <br />
        <ExperienceRating callback={updateAnswer} defaultValues={loadedAnswers} />
        <br />
        <YesNoQuestion other={true} callback={updateAnswer} defaultValues={loadedAnswers} field="menu_variety" label="*هل وجدت تنوع  في قائمة الطعام والمشروبات ال Menu لدينا؟" />
        <br />
        <YesNoQuestion other={true} callback={updateAnswer} defaultValues={loadedAnswers} field="opening_hours" label="*هل أنت راضٍ عن ساعات عملنا؟" />
        <br />
        <SingleChoiceQuestion other={true} callback={updateAnswer} defaultValues={loadedAnswers} field="staff_interaction" label="*ما مدى رضاك عن تعامل الموظفين مع الزبائن؟" options={["ممتاز", "جيد جدا", "متوسط", "سيئ"]} />
        <br />
        <YesNoQuestion other={true} callback={updateAnswer} defaultValues={loadedAnswers} field="customer_handling" label="*هل سبق وأن تمت معاملتك بطريقة غير مرضية من قبل فريق العمل ؟" description="في حال أجبت بنعم سيتم التواصل معك من قبل الفريق لمعالجة المشكلة في حال موافقتكم" />
        <br />
        <SingleChoiceQuestion callback={updateAnswer} defaultValues={loadedAnswers} field="price" label="*برأيك أسعار الوجبات المقدمة في المطعم" options={["مشجعة جداً", "مقبولة", "مرتفعة"]} />
        <br />
        <SingleChoiceQuestion callback={updateAnswer} defaultValues={loadedAnswers} field="get_to_know" label="*كيف عرفت عن مطعمنا في زيارتك الأولى؟" options={["وجدت إعلان للمطعم على مواقع التواصل الاجتماعي", "رشحه لك أحد الأصدقاء أو أحد أفراد العائلة", "مررت من أمامه بالصدفة وأردت تجربته"]} />
        <br />
        <YesNoQuestion other={true} callback={updateAnswer} defaultValues={loadedAnswers} field="comeback" label="*هل ترغب بزيارة مطعمنا مرة أخرى؟" />
        <br />
        <SingleChoiceQuestion other={true} callback={updateAnswer} defaultValues={loadedAnswers} field="reasons_to_visit" label="*ما هي الأسباب التي شجعتك على زيارتنا ؟" options={["جودة الأطعمة والمشروبات", "جودة الأركيلة وخدمتها", "المعاملة الجيدة من الفريق", "الجو والراحة العامة في المطعم", "الأسعار المنافسة"]} />
        <br />
        <CommentsCard callback={updateAnswer} defaultValues={loadedAnswers} />
        <br />
        <br />
        {loadedAnswers ? <></> : (
          successSend ? <div style={{
            padding: "1rem",
            textAlign: "center",
            marginBottom: "6rem"
          }}>
            <div style={{ color: "#2cb052", marginBottom: "1rem", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>نجاح <DoneIcon /></div>
            <div><b>شكرا لإجاباتك!</b></div>
          </div> : <><LoadingButton
            id="send-button"
            loading={sending}
            variant="outlined"
            size="small"
            fullWidth
            sx={{
              display: "flex",
              padding: "1rem",
              background: "#eb6123",
              marginBottom: "0.5rem",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={saveAnswer}>
            <div style={{
              width: "100%",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <b>أرسل إجابات</b>
              <span style={{ marginLeft: "1rem", display: "flex" }}><SendIcon /></span>
            </div>
          </LoadingButton>
            {sendError && <div style={{ color: "red", marginBottom: "1rem" }}>{sendError}</div>}
            <div style={{ marginBottom: "6rem", color: "white" }}>
              <a target="_blank" href="https://www.privacypolicygenerator.info/live.php?token=wGGtkHFI3MdKx5HpDWSZYKwI42xkUbse" rel="nofollow"> سياسة الخصوصية </a>أنت توافق على
            </div>
          </>)}
      </div>
    </div >
  );
}

export default App;
